import {
  ArrayInput,
  BooleanInput,
  Create,
  FormTab,
  ImageField,
  ImageInput,
  NumberInput,
  required,
  ResourceComponentProps,
  SelectInput,
  SimpleFormIterator,
  TabbedForm,
  TextInput,
  useNotify,
  useRedirect,
} from "react-admin";
import { uploadImage } from "./imageUpload";
import {
  GraphTypes,
  MachineTypes,
  TelemetryDataTypes,
  TelemetryTypes,
} from "./choices";

export const MachineDefinitionCreate = (props: ResourceComponentProps) => {
  const notify = useNotify();
  const redirect = useRedirect();
  let imageToUpload: File;

  // Remove file raw data from creation command
  const transform = (data: any) => {
    imageToUpload = data.image.rawFile;

    const dataToGo = data;
    delete dataToGo.image;
    return dataToGo;
  };

  const onSuccess = (successResponse: any) => {
    uploadImage(
      successResponse.data.imageUploadLink,
      imageToUpload,
      (result) => {
        notify("ra.notification.created", "info", {
          messageArgs: { smart_count: 1 },
        });
        redirect(
          "show",
          props.basePath,
          successResponse.data.id,
          successResponse.data.machineDefinition
        );
      },
      (err) => {
        notify("ra.notification.created", "info", {
          messageArgs: { smart_count: 1 },
        });
        redirect(
          "show",
          props.basePath,
          successResponse.data.id,
          successResponse.data.machineDefinition
        );
      }
    );
  };

  return (
    <Create {...props} transform={transform} onSuccess={onSuccess}>
      <TabbedForm>
        <FormTab label="Sources">
          <TextInput source="name" validate={required()} />
          <SelectInput
            source="type"
            choices={MachineTypes}
            validate={required()}
          />
          <ImageInput
            source="image"
            label="Machine Image"
            accept="image/*"
            multiple={false}
            validate={required()}>
            <ImageField source="src" title="title" />
          </ImageInput>
          <ArrayInput source="telemetry" validate={required()}>
            <SimpleFormIterator>
              <TextInput
                source="name"
                options={{ label: "Name" }}
                validate={required()}
              />
              <TextInput
                source="label"
                options={{ label: "Label" }}
                validate={required()}
              />
              <TextInput
                source="unit"
                options={{ label: "Unit" }}
                validate={required()}
              />
              <SelectInput
                source="type"
                options={{ label: "Telemetry Type" }}
                choices={TelemetryTypes}
                validate={required()}
              />
              <SelectInput
                source="dataType"
                options={{ label: "Data Type" }}
                choices={TelemetryDataTypes}
                validate={required()}
              />
              <BooleanInput
                source="log"
                label={"Log changes?"}
                defaultValue={false}
                validate={required()}
              />
              <BooleanInput
                source="sms"
                label={"Send SMS?"}
                defaultValue={false}
                validate={required()}
              />
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>

        <FormTab label="Alarms">
          <ArrayInput source="alarms" validate={required()}>
            <SimpleFormIterator>
              <TextInput
                source="id"
                label={"Sensor Id"}
                validate={required()}
              />

              <ArrayInput
                source="definition"
                label={"Alarm Definition"}
                validate={required()}>
                <SimpleFormIterator>
                  <TextInput
                    source="name"
                    label={"Name"}
                    validate={required()}
                  />
                  <TextInput
                    source="text"
                    label={"Text"}
                    validate={required()}
                  />
                  <BooleanInput
                    source="sms"
                    label={"Send SMS?"}
                    defaultValue={false}
                    validate={required()}
                  />
                </SimpleFormIterator>
              </ArrayInput>
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>

        <FormTab label="Notifications">
          <ArrayInput source="notifications" validate={required()}>
            <SimpleFormIterator>
              <TextInput
                source="id"
                label={"Sensor Id"}
                validate={required()}
              />
              <ArrayInput
                source="definition"
                label={"Notification Definition"}
                validate={required()}>
                <SimpleFormIterator>
                  <TextInput
                    source="name"
                    label={"Name"}
                    validate={required()}
                  />
                  <TextInput
                    source="text"
                    label={"Text"}
                    validate={required()}
                  />
                  <BooleanInput
                    source="sms"
                    label={"Send SMS?"}
                    defaultValue={false}
                    validate={required()}
                  />
                </SimpleFormIterator>
              </ArrayInput>
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>

        <FormTab label="Graphs">
          <ArrayInput source="graphs" validate={required()}>
            <SimpleFormIterator>
              <TextInput source="label" label="label" validate={required()} />

              <TextInput source="valueFormatter" label="Value Formatter" placeholder="D144 or D144/1000" />

              <NumberInput
                source="lastMinutes"
                label="Show last minutes"
                validate={required()}
              />

              <BooleanInput
                source="fullWidth"
                label="Full Width"
                validate={required()}
                defaultValue={false}
              />
              <SelectInput
                source="graphType"
                options={{ label: "Graph Type" }}
                choices={GraphTypes}
                validate={required()}
              />

              <ArrayInput
                source="dataSources"
                label="Sources"
                validate={required()}>
                <SimpleFormIterator disableReordering>
                  <TextInput
                    source="sensorId"
                    label="Sensor Id"
                    validate={required()}
                  />
                  <TextInput
                    source="color"
                    label="Line color"
                    validate={required()}
                  />
                </SimpleFormIterator>
              </ArrayInput>
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
